import { Machine, assign } from 'xstate'
import fetch from 'isomorphic-unfetch'

import CONFIG from 'isomorphic-config'

export const invokeFetchCurrentCityData = ({ position }) => {
  const { coords = {} } = position
  const { latitude = '', longitude = '' } = coords
  const url = `${CONFIG.client.search.retail.hotels}geo/${latitude}/${longitude}/5?version=1`

  return fetch(url)
    .then(res => res.json())
    .then(data => {
      const exactCityMatch = data?.exactMatch?.matchedCity
      const itemText = data?.exactMatch?.displayText ?? ''
      const itemName = itemText
      const content = itemText
      const type = 'GEO'
      const lat = data?.searchedLocation?.lat ?? ''
      const lon = data?.searchedLocation?.lon ?? ''
      const cityID = exactCityMatch?.cityID ?? ''
      return {
        itemName,
        content,
        type,
        lat,
        lon,
        cityID
      }
    })
}

const updatePosition = assign({
  position: (_, event) => event.position
})

export function geoService() {
  return cb => {
    if (!navigator.geolocation) {
      cb({
        type: 'error',
        error: new Error('Geolocation is not supported')
      })
      return
    }

    const geoWatch = navigator.geolocation.watchPosition(
      // sends back to parent
      position => cb({ type: 'success', position }),
      error => cb({ type: 'error', error })
    )

    // disposal function
    return () => navigator.geolocation.clearWatch(geoWatch)
  }
}

const shouldRequest = context => context.cityData === null

const currentLocationMachine = Machine(
  {
    id: 'geo',
    context: {
      error: null,
      cityData: null,
      position: null
    },
    initial: 'idle',

    states: {
      idle: {
        on: {
          REQUEST: [
            {
              target: 'pending',
              cond: shouldRequest
            },
            {
              target: 'resolved'
            }
          ]
        }
      },
      pending: {
        invoke: {
          src: 'geoService'
        },
        on: {
          success: {
            target: 'gettingCurrentCity',
            actions: 'updatePosition'
          },
          error: {
            target: 'rejected',
            actions: assign({
              error: (_, event) => event.error
            })
          }
        }
      },
      gettingCurrentCity: {
        invoke: {
          src: invokeFetchCurrentCityData,
          onDone: {
            target: 'resolved',
            actions: assign({
              cityData: (_, event) => event.data
            })
          },
          onError: {
            target: 'rejected',
            actions: assign({
              error: (_, event) => event.data
            })
          }
        }
      },
      resolved: {},
      rejected: {}
    }
  },
  {
    actions: { updatePosition },
    services: { geoService }
  }
)
export default currentLocationMachine
